// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"93a3b1e5","406":"54d4ea98","478":"5eb303e4","540":"37fb1a58"}[chunkId] + ".chunk.css";
};